import { Injectable } from "@angular/core";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { tap } from "rxjs/operators";
import { getUpdatedItems } from "../../../../shared/utils/utils";
import { AdminPagesStateDefaults } from "../../admin.state";
import { ToolAllowanceService } from "../tool-allowance.service";
import { AddToolAllowance, LoadToolAllowance, RemoveToolAllowance, UpdateToolAllowance } from "./tool-allowance.actions";
import { ToolAllowanceStateModel } from "./tool-allowance.model";

@State<ToolAllowanceStateModel>({
	name: "toolAllowance",
	defaults: AdminPagesStateDefaults
})
@Injectable()
export class ToolAllowanceState {

	constructor(private toolAllowanceService: ToolAllowanceService) { }

	@Selector() static codes(state: ToolAllowanceStateModel) { return state.items; }
	@Selector() static loading(state: ToolAllowanceStateModel) { return state.loading; }
	@Selector() static saving(state: ToolAllowanceStateModel) { return state.saving; }

	@Action(LoadToolAllowance)
	load(ctx: StateContext<ToolAllowanceStateModel>) {
		ctx.patchState({ items: [], loading: true });

		return this.toolAllowanceService.getToolAllowances().pipe(
			tap(
				(response) => {
					ctx.patchState({
						items: response.items,
						loaded: true,
						loading: false
					});
				}
			)
		);
	}

	@Action(AddToolAllowance)
	addToolAllowance(ctx: StateContext<ToolAllowanceStateModel>, action: AddToolAllowance) {
		ctx.patchState({ saving: true });

		return this.toolAllowanceService.create(action.payload).pipe(
			tap(
				(response) => {
					action.callbackSuccess();
					const state = ctx.getState();
					ctx.patchState({
						items: [response, ...state.items],
						saving: false 
					});
				},
				(error) => {
					action.callbackError(error);
					ctx.patchState({ saving: false });
				}
			)
		);
	}

	@Action(UpdateToolAllowance)
	updateToolAllowance(ctx: StateContext<ToolAllowanceStateModel>, action: UpdateToolAllowance) {
		ctx.patchState({ saving: true });

		return this.toolAllowanceService.update(action.payload).pipe(
			tap(
				(response) => {
					action.callbackSuccess();
					const state = ctx.getState();
					ctx.patchState({
						items: getUpdatedItems(response, state.items),
						saving: false
					});
				},
				(error) => {
					action.callbackError(error);
					ctx.patchState({ saving: false });
				}
			)
		);
	}

	@Action(RemoveToolAllowance)
	removeToolAllowance(ctx: StateContext<ToolAllowanceStateModel>, action: RemoveToolAllowance) {
		return this.toolAllowanceService.remove(action.id).pipe(
			tap(
				() => {
					action.callbackSuccess();
					const state = ctx.getState();
					const updated = state.items.filter(item => {
						return item.id !== action.id;
					});
					ctx.patchState({ items: updated });
				},
				(error) => {
					action.callbackError();
				}
			)
		);
	}
}
